import { SerializedError } from '@reduxjs/toolkit';
import { QueryActivityPageDetail, QueryActivityPageSummary } from '../../../api/schema';

/**
 * Summaries and drill-downs are kept per request rather than as a single
 * "current" value: toggling the period or opening a sub-period would otherwise
 * show the previous window's numbers under the new window's heading until the
 * response landed.
 */
export interface ActivityState {
  fetching: { [key: string]: boolean };
  summary: { [key: string]: QueryActivityPageSummary };
  detail: { [key: string]: QueryActivityPageDetail };
  error?: SerializedError;
}

export const initialState: ActivityState = {
  fetching: {},
  summary: {},
  detail: {},
};

/** summaryKey and detailKey identify one request's worth of data. */
export const summaryKey = (period: string, mode: string): string => `${period}|${mode}`;
export const detailKey = (from: string, to: string): string => `${from}|${to}`;
